import React from 'react'
import { Checkbox, Input, Switch } from 'antd'
import { FormikHelpers, FormikState } from 'formik'
import { AdminsFinanceCreateVendorRequest } from 'generated/api'
import Card from 'components/card/Card'
import CardHeaderForm from 'components/card/CardHeaderForm'
import clsx from 'clsx'

interface AdditionalInformationProps {
  state: FormikState<AdminsFinanceCreateVendorRequest>
  helpers: FormikHelpers<AdminsFinanceCreateVendorRequest>
}

export default function FormAdditionalInformation(props: AdditionalInformationProps) {
  const { state, helpers } = props

  return (
    <Card className="rounded-xl py-6 px-0">
      <CardHeaderForm title="4. Informasi Tambahan" />
      <Card.Body className="mt-0 px-6">
        <div className="flex flex-col gap-3 xl:gap-9">
          <div className="xl:flex xl:gap-6">
            <div className="xl:w-3/12 self-center">
              <label className="text-base font-medium text-[#323539] m-0 block">
                Kenakan Pajak
              </label>
            </div>
            <div className="xl:w-9/12">
              <Switch
                checked={state.values.isTax}
                onChange={checked => helpers.setFieldValue('isTax', checked)}
              />
            </div>
          </div>
        </div>
        <hr className="my-6 border-[#E1E6EF] border-solid" />
        <div className="flex flex-col gap-3 xl:gap-9">
          <div className="xl:flex xl:gap-6">
            <div className="xl:w-3/12 self-center">
              <label className="flex flex-col font-medium text-[#323539] m-0 block">
                <span className="text-base font-bold antialiased">Fasilitas Vendor</span>
                <span className="text-xs antialiased font-[#596574]">
                  Pilih jenis fasilitas yang dimiliki oleh vendor
                </span>
              </label>
            </div>
            <div className="xl:w-9/12">
              <div className="w-full xl:grid xl:grid-cols-2 xl:gap-3 checkbox-admin">
                <div className="px-2 py-4 rounded-lg border-2 border-solid border-[#E5E5E7]">
                  <Checkbox
                    checked={state.values.isPC}
                    onChange={() => helpers.setFieldValue('isPC', !state.values.isPC)}
                  >
                    <div className="flex gap-4 pl-2">
                      <span className="self-center text-[#323539]">
                        Memiliki PC / Komputer / Laptop
                      </span>
                    </div>
                  </Checkbox>
                </div>
                <div className="px-2 py-4 rounded-lg border-2 border-solid border-[#E5E5E7]">
                  <Checkbox
                    checked={state.values.isFleet}
                    onChange={() => {
                      helpers.setFieldValue('isFleet', !state.values.isFleet)
                      helpers.setFieldValue('fleetType', '')
                    }}
                  >
                    <div className="flex gap-4 pl-2">
                      <span className="self-center text-[#323539]">Memiliki Unit Kendaraan</span>
                    </div>
                  </Checkbox>
                </div>
                <div className="px-2 py-4 rounded-lg border-2 border-solid border-[#E5E5E7]">
                  <Checkbox
                    checked={state.values.isWifi}
                    onChange={() => helpers.setFieldValue('isWifi', !state.values.isWifi)}
                  >
                    <div className="flex gap-4 pl-2">
                      <span className="self-center text-[#323539]">Tersedia Jaringan Internet</span>
                    </div>
                  </Checkbox>
                </div>
                <div className="px-2 py-4 rounded-lg border-2 border-solid border-[#E5E5E7]">
                  <Checkbox
                    checked={state.values.isWarehouse}
                    onChange={() => helpers.setFieldValue('isWarehouse', !state.values.isWarehouse)}
                  >
                    <div className="flex gap-4 pl-2">
                      <span className="self-center text-[#323539]">Memiliki Gudang</span>
                    </div>
                  </Checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        {state.values.isFleet ? (
          <>
            <hr className="my-6 border-[#E1E6EF] border-solid" />
            <div className="flex flex-col gap-3 xl:gap-9">
              <div className="xl:flex xl:gap-6">
                <div className="xl:w-3/12 self-center">
                  <label className="text-base font-bold antialiased text-[#323539] m-0 block">
                    Tipe Armada
                  </label>
                </div>
                <div className="xl:w-9/12">
                  <Input
                    id="fleetType"
                    name="fleetType"
                    className={`rounded-lg px-4 py-2 w-full xl:w-2/5 border-solid border-2 ${clsx({
                      'border-[#E5E5E7]': !state.errors.fleetType && !state.touched.fleetType,
                    })}`}
                    placeholder="Masukkan Detail Kendaraan yang dimiliki Vendor"
                    value={state.values.fleetType}
                    onChange={e => {
                      helpers.setFieldTouched('fleetType', true)
                      helpers.setFieldValue('fleetType', e.target.value)
                    }}
                    status={state.errors.fleetType && state.touched.fleetType ? 'error' : ''}
                  />
                </div>
              </div>
            </div>
          </>
        ) : null}
      </Card.Body>
    </Card>
  )
}
